import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { activeStylesContinue } from "../../configs";
import { findBrandByDomain } from "../../configs/configLoader";
import { hoverStylesContinue } from "../../configs/stylesLoader";
import { ArrowForward as ChevronRight } from "@mui/icons-material";

import "./index.css";

interface IPropsResultError {
  step: any;
  nextStep: () => void;
}

const ResultError: FC<IPropsResultError> = ({ step, nextStep }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const isLargeHeightRelative = useMediaQuery({
    maxHeight: 778,
    minWidth: 767,
  });

  const { t } = useTranslation("components/device_select");

  const [hovered, setHovered] = useState(false);

  const brandDefined = findBrandByDomain();

  const isIntersport = brandDefined?.name === "Intersport";
  const isBlackstore = brandDefined?.name === "Blackstore";
  const isCustomBrands = isIntersport || isBlackstore;

  const mergedButtonStyles: React.CSSProperties = {
    ...(isCustomBrands ? activeStylesContinue : {}),
    ...(isIntersport && hovered ? hoverStylesContinue : {}),
    textTransform:
      activeStylesContinue.textTransform === "capitalize"
        ? "none"
        : activeStylesContinue.textTransform,
    position: "relative",
    padding: "16px",
    height: "auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "visible",
    marginTop: "317px",
    marginBottom: "50px",
  };

  const arrowContainerStyle: React.CSSProperties = {
    display: "inline-block",
    width: hovered ? 16 : 0,
    overflow: "hidden",
    verticalAlign: "middle",
    transition: "width 160ms ease",
  };

  const iconStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    opacity: hovered ? 1 : 0,
    transform: hovered ? "translateX(0)" : "translateX(-6px)",
    transition: "opacity 160ms ease, transform 160ms ease",
    display: "inline-block",
    verticalAlign: "middle",
    pointerEvents: "none",
  };

  return (
    <div
      className="result-error"
      style={{
        marginTop: isLargeHeightRelative ? "30px" : isMobile ? 0 : "40px",
      }}
    >
      <span
        className="description"
        style={{
          fontSize: "13px",
          fontWeight: "400",
          color: "#2E2E2E",
          marginTop: "20px",
        }}
      >
        {t("error.description")}
      </span>
      <button
        type="button"
        className="continue-button"
        onClick={() => {
          nextStep();
        }}
        style={mergedButtonStyles}
        onMouseEnter={() => {
          setHovered(true);
        }}
        onMouseLeave={() => {
          setHovered(false);
        }}
      >
        <div style={{ display: "inline-flex", alignItems: "center", gap: 0 }}>
          {t("error.skip")}

          {isIntersport && (
            <span style={arrowContainerStyle} aria-hidden>
              <ChevronRight style={iconStyle} />
            </span>
          )}
        </div>
      </button>
    </div>
  );
};

export default ResultError;
